import {appEnv} from '@/appEnv'
import axios from 'axios'

export interface RequestBodyType {
  email: string
  phone: string
  name: string
  address: string
  postalCode: string
  postOffice: string
}

export const registerUser = ({
  email,
  phone,
  name,
  address,
  postOffice,
  postalCode,
}: RequestBodyType) => {
  return axios.post(`${appEnv.API_RAFFLE_URL}/submit`, {
    game: 'S',
    game_type: 'single',
    email,
    phone,
    name,
    address,
    post_office: postOffice,
    postal_code: postalCode,
  })
}
